import { useEffect, useRef, useState } from "react";
import { TrashIcon } from "../../../../../assets/icons";
import ActiveFilterTag, { CarouselFilter } from "../_activeFilterTag";
import "./index.scss";

interface ActiveFilterTagCarouselProps {
  filters: CarouselFilter[];
  onRemove: (filter: CarouselFilter) => void;
  onClearAll?: () => void;
}

const ActiveFilterTagCarousel = ({
  filters,
  onRemove,
  onClearAll,
}: ActiveFilterTagCarouselProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (direction: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 200;
    el.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);
    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [filters]);

  if (!filters.length) return null;

  return (
    <div className="active-filter-carousel d-flex align-items-center">
      {canScrollLeft && (
        <button
          type="button"
          className="scroll-btn left"
          onClick={() => scroll("left")}
        >
          ‹
        </button>
      )}

      <div className="filters-wrapper flex-grow-1" ref={scrollRef}>
        <div className="filters-inner d-inline-flex align-items-center">
          <button
            type="button"
            className="btn btn-sm clear-filters-btn d-flex align-items-center"
            onClick={onClearAll}
          >
            <TrashIcon />
            <span>Limpar Filtros</span>
          </button>

          {filters.map((filter, index) => (
            <ActiveFilterTag
              key={`carrouse-filter-${index}`}
              filter={filter}
              onRemove={onRemove}
            />
          ))}
        </div>
      </div>

      {canScrollRight && (
        <button
          type="button"
          className="scroll-btn right"
          onClick={() => scroll("right")}
        >
          ›
        </button>
      )}
    </div>
  );
};

export default ActiveFilterTagCarousel;
